import React, { useReducer, useContext, useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import {
  Button,
  Icon,
  TextField,
  Paper,
  Typography,
  InputAdornment,
} from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Modal from '@material-ui/core/Modal'
import HomeIcon from '@material-ui/icons/Home'
import Input from '@material-ui/core/Input'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import CancelIcon from '@material-ui/icons/Cancel'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import Checkbox from '@material-ui/core/Checkbox'
import { makeStyles } from '@material-ui/core/styles'
import Amplify, { Auth } from 'aws-amplify'
import ReactCodeInput from 'react-code-input'
import { Context as LoginContext } from '../contexts/login'
import sentEmail from '../assets/images/sentEmail.svg'
import changePassOk from '../assets/images/changePassOk.svg'
import SpinnerIcon from '../assets/images/spinner.gif'
import aws_exports from '../aws-exports'
import { SIGNUP_PATHNAME } from '../constants/RoutePathName'
import { getCookie, setCookieHelper } from '../ultils/cookie'
import { EXPIRED_SECOND } from '../constants/Cookie'
import { codeInputStyles } from '../ultils/loginUtils'

Amplify.configure(aws_exports)

const useStyles = makeStyles(theme => ({
  lgCustomGridContainer: {
    width: '100%',
    height: '100%',
    margin: 'unset',
    background: 'white',
  },
  lgBanner: {
    height: '100%',
    width: '100%',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  lgCustomeBackText: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 400,
    color: '#3393F3',
    marginLeft: 8,
  },
  lgWelcomeText: {
    fontSize: 28,
    lineHeight: '36px',
    fontWeight: 600,
    color: '#181818',
  },
  lgHeadTitle: {
    color: '#7688A1',
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
  },
  lgFormContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    paddingTop: 20,
  },
  lgBackToHomeContainer: {
    marginBottom: '120px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  lgCustomFormControl: {
    width: '100%',
    boxSizing: 'border-box',
  },
  lgSocialButton: {
    height: 50,
    width: 212,
    border: '1px solid #DFE4EB',
    borderRadius: 3,
    fontSize: 12,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#474747',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 6,
    boxSizing: 'border-box',
  },
  lgMissAccount: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: '#474747',
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    textAlign: 'center',
  },
  lgCreateAccountText: {
    color: '#3393f3',
    marginLeft: 8,
  },
  lgInputTitleText: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 600,
    marginBottom: 10,
  },
  lgCustomInput: {
    height: 40,
    width: '100%',
    borderRadius: 3,
    border: 'none',
    background: '#F4F5F7',
    boxSizing: 'border-box',
    padding: '0px 12px',
    color: '#181818',
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    '&:before': {
      display: 'none',
    },

    '&:after': {
      display: 'none',
    },
  },
  lgFogetPass: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#3393F3',
    cursor: 'pointer',
  },
  lgCustomCheckBox: {
    '.MuiTypography-root': {
      fontSize: 14,
      lineHeight: '22px',
      fontWeight: 400,
      color: '#474747',
    },
  },
  lgCustomSubmitBtn: {
    background: '#1B3963',
    borderRadius: 3,
    width: '100%',
    height: 40,

    '&:hover': {
      backgroundColor: '#1B3963',
    },
  },
  lgCustomSubmitBtnText: {
    color: '#FFFFFF',
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
  },
  lgSocialButtonWithText: {
    fontWeight: 400,
    marginLeft: 8,
  },

  lgSocialButtonBrand: {
    fontWeight: 700,
    color: 'black',
    marginLeft: 8,
  },
  lgCustomInputHint: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 400,
    color: '#DE3131',
    textAlign: 'right',
  },
  lgResetPassModalContainer: {
    background: '#FFFFFF',
    border: '1px solid #DFE4EB',
    boxSizing: 'border-box',
    borderRadius: 5,
    padding: '40px 50px',
    width: 500,
    outline: 'none',
    position: 'relative',
  },
  resetPasswordModal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  lgCloseIcon: {
    position: 'absolute',
    top: 20,
    right: 20,
    cursor: 'pointer',
  },
  lgResetPassTitle: {
    fontSize: 18,
    lineHeigt: '26px',
    fontWeight: 600,
    color: '#474747',
    textAlign: 'center',
  },
  lgResetPassHint: {
    fontSize: 14,
    lineHeigt: '22px',
    fontWeight: 400,
    color: '#5E5E5E',
    textAlign: 'center',
  },
  lgCheckYourEmail: {
    fontSize: 18,
    lineHeight: '26px',
    fontWeight: 600,
    color: '#181818',
  },
  lgSentYourEmail: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#474747',
    textAlign: 'center',
  },
  lgYourEmail: {
    color: '#3393F3',
    marginLeft: 8,
  },
  lgSentYourEmailGuide: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#474747',
  },
  lgAskResent: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#474747',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  lgAskResentEmail: {
    marginLeft: 8,
    color: '#3393F3',
  },
  lgCompanyLogo: {
    marginTop: 40,
    marginLeft: 40,
  },
  lgCustomCheckBoxHint: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#474747',
  },
  iconHelperContainer: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  lgCustomInputWarning: {
    border: '1px solid #DE3133',
  },
  spinnerIcon: {
    width: 20,
    marginLeft: 8,
  },
  lgLoginWarning: {
    color: '#DE3131',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
    marginTop: 10,
  },
  loginContainer: {
    height: '100vh',
    padding: 20,
    background: 'white',
  },
  helperIconStyle: {
    color: '#8C8C8C',
    width: 20,
    height: 20,
  },
  emailInputContainer: {
    position: 'relative',
  },
  lgCustomInputHintEmail: {
    position: 'absolute',
    right: 0,
    marginTop: 2,
  },
  HomeIcon: {
    color: '#7688A1',
    width: 20,
    position: 'relative',
    top: -1,
  },
}))

const EMAIL_PROP_NAME = 'email'
const PASSWORD_PROP_NAME = 'password'
const VALIDATION_EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
const TYPE_PASSWORD = 'password'
const TYPE_TEXT = 'text'
const FILL_ALL_INPUT_WARNING = 'Please fill all fields !'

const deepUpdateObject = (obj: any, propName: string, val: any) => {
  const cloned = JSON.parse(JSON.stringify(obj))
  cloned[propName] = val
  return cloned
}

const isValidEmail = (email: string) => VALIDATION_EMAIL_REGEX.test(email)

const LoginPageMobile = (props: any) => {
  const classes = useStyles()
  const history = useHistory()
  const [open, setOpen] = useState(false)
  const [loginData, setLoginData] = useState({
    email: '',
    password: '',
  })
  const [togglePasswordType, seTogglePasswordType] = useState(false)
  const [isStartLogin, setIsStartLogin] = useState(false)
  const [isKeepSubmitting, setIsKeepSubmitting] = useState(true)
  const [loginResultMessage, setLoginResultMessage] = useState('')
  const { state, updateLoginResult } = useContext(LoginContext)
  const [mode, setMode] = useState(0)
  const [skipResetCode, setSkipResetCode] = useState(false)
  const [resetUser, setResetUser] = useState<any>({})

  const handleOpen = () => {
    setSkipResetCode(false)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const onHandleClearEmailInput = () => {
    setLoginData(deepUpdateObject(loginData, EMAIL_PROP_NAME, ''))
  }

  const onHandleVisiblePassword = () => {
    seTogglePasswordType(!togglePasswordType)
  }

  const isActiveInvalidEmailWarning =
    loginData.email.length !== 0 && !isValidEmail(loginData.email)

  const onHandleLoginInputChange = (event: any, type: string) => {
    let clonedLoginData = null
    setLoginResultMessage('')

    switch (type) {
      case EMAIL_PROP_NAME:
        setLoginData(
          deepUpdateObject(loginData, EMAIL_PROP_NAME, event.target.value),
        )
        break
      case PASSWORD_PROP_NAME:
        setLoginData(
          deepUpdateObject(loginData, PASSWORD_PROP_NAME, event.target.value),
        )
        break
      default:
    }
  }

  const onSubmitLogin = (event: any) => {
    event.preventDefault()
    if (loginData.email === '' || loginData.password === '') {
      setLoginResultMessage(FILL_ALL_INPUT_WARNING)
      return
    }

    setIsStartLogin(true)
    if (isKeepSubmitting) {
      setIsKeepSubmitting(false)
      Auth.signIn(loginData.email, loginData.password)
        .then((user: any) => {
          if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            setSkipResetCode(true)
            setResetUser(user)
            setMode(2)
            setOpen(true)
            setIsStartLogin(false)
            setIsKeepSubmitting(true)
          } else {
            setCookieHelper('name', user.attributes.name, EXPIRED_SECOND)
            setIsStartLogin(false)
            setIsKeepSubmitting(true)
            setLoginResultMessage('')
            updateLoginResult(
              user.signInUserSession.accessToken.jwtToken,
              user.signInUserSession.idToken.jwtToken,
              user.signInUserSession.refreshToken.token,
              user.attributes.email,
            )
            const originPath = getCookie('originPath')
            if (originPath) {
              history.push(originPath)
            } else {
              history.push('/')
            }
          }
        })
        .catch((err: any) => {
          setIsStartLogin(false)
          setIsKeepSubmitting(true)
          setLoginResultMessage(err.message)
        })
    }
  }

  const resetEmailRef = React.useRef<string>('')

  const ResetPasswordModalBody = (props: any) => {
    const [isStartSending, setIsStartSending] = useState(false)
    const [resetEmail, setResetEmail] = useState('')
    const isActiveInvalidResetEmailWarning =
      resetEmail.length !== 0 && !isValidEmail(resetEmail)
    const onHandleChangeEmailResetPass = (event: any) => {
      setResetEmail(event.target.value)
    }
    const onHandClearResetEmailInput = () => {
      setResetEmail('')
    }
    const onHandleSendResetCode = async () => {
      if (!isActiveInvalidResetEmailWarning && resetEmail.length !== 0) {
        setIsStartSending(true)
        try {
          const result = await Auth.forgotPassword(resetEmail)
          setIsStartSending(false)
          resetEmailRef.current = resetEmail
          setMode(2)
        } catch (err) {
          setIsStartSending(false)
        }
      }
    }
    const [newPwd, setNewPwd] = React.useState('')
    const [newPwdConfirmed, setPwdConfirmed] = React.useState<string>('')
    const [code, setCode] = React.useState('')
    const startConfirmedFlag = React.useRef<boolean>(false)
    const [err, setErr] = React.useState<string>('')
    const onNewPwdConfirmed = (confirmedPwd: string) => {
      startConfirmedFlag.current = true
      setPwdConfirmed(confirmedPwd)
    }

    const onSubmitNewPassword = async (e: any) => {
      e.preventDefault()
      setIsStartSending(true)
      if (skipResetCode) {
        // first time login
        try {
          await Auth.completeNewPassword(resetUser, newPwd, {
            name: resetUser?.userAttributes?.name || 'Name',
          })
          setIsStartSending(false)
          setMode(3)
        } catch (error) {
          setIsStartSending(false)
          setErr(error.message)
        }
      } else {
        // forgot password
        try {
          await Auth.forgotPasswordSubmit(resetEmailRef.current, code, newPwd)
          setIsStartSending(false)
          setMode(3)
        } catch (error) {
          setIsStartSending(false)
          setErr(error.message)
        }
      }
    }

    return (
      <div className={classes.lgResetPassModalContainer}>
        <div onClick={props.handleClose} className={classes.lgCloseIcon}>
          <CancelIcon className={classes.helperIconStyle} />
        </div>

        {mode === 0 && (
          <Box>
            <Box mb="16px">
              <Typography className={classes.lgResetPassTitle}>
                Reset Password
              </Typography>
            </Box>
            <Box mb="24px">
              <Typography className={classes.lgResetPassHint}>
                Please enter your email address to reset your password
              </Typography>
            </Box>
            <Box mb="20px" className={classes.emailInputContainer}>
              <Typography className={classes.lgInputTitleText}>
                Email
              </Typography>
              <Input
                aria-describedby="email"
                className={`${classes.lgCustomInput} ${
                  isActiveInvalidResetEmailWarning
                    ? classes.lgCustomInputWarning
                    : ''
                }`}
                placeholder="Type in your email"
                type="text"
                onChange={onHandleChangeEmailResetPass}
                value={resetEmail}
                endAdornment={
                  <InputAdornment position="end">
                    {resetEmail.length !== 0 && (
                      <CancelIcon
                        onClick={onHandClearResetEmailInput}
                        className={classes.helperIconStyle}
                      />
                    )}
                  </InputAdornment>
                }
              />
              {isActiveInvalidResetEmailWarning && (
                <FormHelperText
                  className={`${classes.lgCustomInputHint} ${classes.lgCustomInputHintEmail}`}
                >
                  Please enter a valid email
                </FormHelperText>
              )}
            </Box>
            <Button
              type="submit"
              variant="contained"
              className={classes.lgCustomSubmitBtn}
              onClick={onHandleSendResetCode}
            >
              <span className={classes.lgCustomSubmitBtnText}>
                CONTINUE
                {isStartSending && (
                  <img
                    alt="spinner"
                    src={SpinnerIcon}
                    className={classes.spinnerIcon}
                  />
                )}
              </span>
            </Button>
          </Box>
        )}

        {mode === 1 && (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Box mb="30px">
              <img alt="sent" src={sentEmail} />
            </Box>
            <Box mb="16px">
              <Typography className={classes.lgCheckYourEmail}>
                Check your email!
              </Typography>
            </Box>
            <Box mb="10px">
              <Typography className={classes.lgSentYourEmail}>
                We’ve sent an email to{' '}
                <span className={classes.lgYourEmail}>{resetEmail}</span>
              </Typography>
            </Box>
            <Box mb="40px">
              <Typography className={classes.lgSentYourEmailGuide}>
                Follow the link in the email to reset your password.
              </Typography>
            </Box>

            <Box>
              <Typography className={classes.lgAskResent}>
                Didn't receive the link?
                <span className={classes.lgAskResentEmail}>Resend email</span>
              </Typography>
            </Box>
          </Box>
        )}

        {mode === 2 && (
          <Box>
            <Box mb="16px">
              <Typography className={classes.lgResetPassTitle}>
                Reset Password
              </Typography>
            </Box>
            <Box mb="24px">
              <Typography className={classes.lgResetPassHint}>
                Now you can change your password
              </Typography>
            </Box>
            {!skipResetCode && (
              <Box mb="20px">
                <Typography className={classes.lgInputTitleText}>
                  Verification code
                </Typography>
                <div style={{ textAlign: 'center' }}>
                  <ReactCodeInput
                    onChange={setCode}
                    type="text"
                    inputMode="verbatim"
                    fields={6}
                    name="ver-code"
                    inputStyle={codeInputStyles}
                  />
                </div>
              </Box>
            )}
            <Box mb="20px">
              <Typography className={classes.lgInputTitleText}>
                New Password
              </Typography>
              <Input
                onChange={e => setNewPwd(e.target.value)}
                aria-describedby="email"
                className={classes.lgCustomInput}
                placeholder="Type in your new password"
                type="password"
                endAdornment={
                  <InputAdornment position="end">
                    {false && (
                      <VisibilityIcon className={classes.helperIconStyle} />
                    )}
                  </InputAdornment>
                }
              />
              {err && (
                <FormHelperText className={classes.lgCustomInputHint}>
                  {err}
                </FormHelperText>
              )}
            </Box>
            <Box mb="20px">
              <Typography className={classes.lgInputTitleText}>
                Confirm New Password
              </Typography>
              <Input
                onChange={e => onNewPwdConfirmed(e.target.value)}
                aria-describedby="email"
                className={classes.lgCustomInput}
                placeholder="Re-type your new password"
                type="password"
                endAdornment={
                  <InputAdornment position="end">
                    {false && (
                      <VisibilityIcon className={classes.helperIconStyle} />
                    )}
                  </InputAdornment>
                }
              />
              {startConfirmedFlag.current &&
                (!newPwd || newPwdConfirmed !== newPwd) && (
                  <FormHelperText className={classes.lgCustomInputHint}>
                    Password doesn't match
                  </FormHelperText>
                )}
            </Box>
            <Button
              disabled={
                !newPwd ||
                (!code && !skipResetCode) ||
                newPwdConfirmed !== newPwd
              }
              type="submit"
              variant="contained"
              className={classes.lgCustomSubmitBtn}
              onClick={onSubmitNewPassword}
            >
              <span className={classes.lgCustomSubmitBtnText}>
                Reset Password
                {isStartSending && (
                  <img
                    alt="spinner"
                    src={SpinnerIcon}
                    className={classes.spinnerIcon}
                  />
                )}
              </span>
            </Button>
          </Box>
        )}

        {mode === 3 && (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Box mb="30px">
              <img alt="sent" src={changePassOk} />
            </Box>
            <Box mb="16px">
              <Typography className={classes.lgCheckYourEmail}>
                Changed successfully !
              </Typography>
            </Box>
            <Box mb="40px">
              <Typography className={classes.lgSentYourEmail}>
                You can now use your new password to log in to your account.
              </Typography>
            </Box>

            <Button
              type="submit"
              variant="contained"
              className={classes.lgCustomSubmitBtn}
              onClick={() => {
                setOpen(false)
                setMode(0)
              }}
            >
              <span className={classes.lgCustomSubmitBtnText}>Login now</span>
            </Button>
          </Box>
        )}
      </div>
    )
  }

  return (
    <div className={classes.loginContainer}>
      <Grid className={classes.lgCustomGridContainer} container spacing={1}>
        <Grid container xs={12} spacing={0}>
          <Box className={classes.lgFormContainer}>
            <Box>
              <Box className={classes.lgBackToHomeContainer}>
                <HomeIcon className={classes.HomeIcon} />
                <Typography className={classes.lgCustomeBackText}>
                  Back to Home page
                </Typography>
              </Box>

              <Box mb="14px">
                <Typography className={classes.lgWelcomeText}>
                  Welcome
                </Typography>
              </Box>

              <Box mb="30px">
                <Typography className={classes.lgHeadTitle}>
                  Login to stay updated on your dashboard
                </Typography>
              </Box>
              <form
                onSubmit={onSubmitLogin}
                className={classes.lgCustomFormControl}
              >
                <Box mb="20px" className={classes.emailInputContainer}>
                  <Typography className={classes.lgInputTitleText}>
                    Email
                  </Typography>
                  <Input
                    aria-describedby="email"
                    className={`${classes.lgCustomInput} ${
                      isActiveInvalidEmailWarning
                        ? classes.lgCustomInputWarning
                        : ''
                    }`}
                    placeholder="Type in your email"
                    type="text"
                    value={loginData.email}
                    onChange={(event: any) =>
                      onHandleLoginInputChange(event, EMAIL_PROP_NAME)
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        {loginData.email.length !== 0 && (
                          <div
                            className={classes.iconHelperContainer}
                            onClick={onHandleClearEmailInput}
                          >
                            <CancelIcon className={classes.helperIconStyle} />
                          </div>
                        )}
                      </InputAdornment>
                    }
                  />
                  {isActiveInvalidEmailWarning && (
                    <FormHelperText
                      className={`${classes.lgCustomInputHint} ${classes.lgCustomInputHintEmail}`}
                    >
                      Please enter a valid email
                    </FormHelperText>
                  )}
                </Box>

                <Box mb="20px">
                  <Typography className={classes.lgInputTitleText}>
                    Password
                  </Typography>
                  <Input
                    aria-describedby="password"
                    className={classes.lgCustomInput}
                    placeholder="Type in your password"
                    type={togglePasswordType ? TYPE_TEXT : TYPE_PASSWORD}
                    value={loginData.password}
                    onChange={(event: any) =>
                      onHandleLoginInputChange(event, PASSWORD_PROP_NAME)
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        {loginData.password.length !== 0 && (
                          <div
                            className={classes.iconHelperContainer}
                            onClick={onHandleVisiblePassword}
                          >
                            {togglePasswordType ? (
                              <VisibilityIcon
                                className={classes.helperIconStyle}
                              />
                            ) : (
                              <VisibilityOffIcon
                                className={classes.helperIconStyle}
                              />
                            )}
                          </div>
                        )}
                      </InputAdornment>
                    }
                  />
                </Box>

                {loginResultMessage.length !== 0 && (
                  <FormHelperText className={classes.lgLoginWarning}>
                    {loginResultMessage}
                  </FormHelperText>
                )}

                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  mb="30px"
                >
                  <Typography
                    onClick={handleOpen}
                    className={classes.lgFogetPass}
                  >
                    Forgot password ?
                  </Typography>
                </Box>

                <Button
                  type="submit"
                  variant="contained"
                  className={classes.lgCustomSubmitBtn}
                  onClick={onSubmitLogin}
                >
                  <div className={classes.lgCustomSubmitBtnText}>
                    Login
                    {isStartLogin && (
                      <img
                        alt="spinner"
                        src={SpinnerIcon}
                        className={classes.spinnerIcon}
                      />
                    )}
                  </div>
                </Button>
              </form>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Modal
        open={open || mode === 2}
        onClose={handleClose}
        className={classes.resetPasswordModal}
        aria-labelledby="reset-pass-modal-title"
        aria-describedby="reset-pass-modal-description"
      >
        <ResetPasswordModalBody handleClose={handleClose} />
      </Modal>
    </div>
  )
}

export default LoginPageMobile
